const sanitizeFilename = (filename) => {
    if (!filename) return filename;
    return filename.replace(/:/g, '-');
};

const removeFileExtenstion = (filename) => {
    if (!filename) return filename;
    return sanitizeFilename(filename.replace(/\.[^/.]+$/, ''));
};

export {
    sanitizeFilename,
    removeFileExtenstion,
};
